import React from 'react';

const ChurchWoodIcon = (props) => {
  return (
    <img
      alt="Zabytek sakralny drewniany"
      src="/static/images/icons/place_types/church_wood.svg"
      {...props}
    />
  );
};

export default ChurchWoodIcon;
